import * as React from 'react';
import { AccordionContextProps } from './AccordionContext.types';

export const AccordionContext =
  React.createContext<AccordionContextProps>(null);
